import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { m } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useNavigate, Link } from 'react-router-dom';
// Components
import { fadeIn } from '../../Functions/GlobalAnimations';
import Counter from '../../Components/Counters/Counter';
import Tab07 from '../../Components/Tab/Tab07';
import TextSlider02 from '../../Components/TextSlider/TextSlider02';

// Data
import { CounterData02 } from '../../Components/Counters/CounterData';
import { TabData07 } from '../../Components/Tab/TabData';
import { motion } from "framer-motion"

const Home = (props) => {
  const { t, i18n } = useTranslation(); // الوصول إلى الترجمات وإعدادات i18n

  // Déterminer la direction en fonction de la langue
  const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';
  
  // تحديد اتجاه النص بناءً على اللغة
  const isRtl = i18n.language === 'ar';

  // Dans le composant Home
const navigate = useNavigate();
const [searchInput, setSearchInput] = React.useState('');

// Fonction de recherche
const handleSearch = (e) => {
  e.preventDefault();
  if (searchInput.trim()) {
    // Rediriger vers /course avec le terme en query param
    navigate(`/course?search=${encodeURIComponent(searchInput.trim())}`);
  }
};
const [showColorPalette, setShowColorPalette] = useState(false)
  const [selectedBacCategory, setSelectedBacCategory] = useState(null)

  const colorPalette = [
    { hex: "#003479", name: "Dark Blue", label: "Primaire" },
    { hex: "#f29f2f", name: "Orange", label: "Collège" },
    { hex: "#58bceb", name: "Cyan", label: "Secondaire" },
    { hex: "#0879bd", name: "Medium Blue", label: "Baccalauréat" },
  ]

  const bacCategories = [
    { id: 1, name: t('bac.economie_gestion') || "Économie & Gestion", icon: "💼", emoji: true },
    { id: 2, name: t('bac.informatique') || "Informatique", icon: "💻", emoji: true },
    { id: 3, name: t('bac.lettres') || "Lettres", icon: "📚", emoji: true },
    { id: 4, name: t('bac.mathematiques') || "Mathématiques", icon: "🔢", emoji: true },
    { id: 5, name: t('bac.sciences_experimentales') || "Sciences Expérimentales", icon: "🔬", emoji: true },
    { id: 6, name: t('bac.sciences_techniques') || "Sciences Techniques", icon: "⚙️", emoji: true },
  ];

  return (
    <div style={{ ...props.style, direction: direction }}>
      {/* قسم البطل (Hero Section) */}
      <section id="home-section" className="bg-slateGray">
        <div className="container mx-auto min-lg:max-w-screen-xl min-md:max-w-screen-md px-4 py-40">
          <div className="grid grid-cols-1 min-lg:grid-cols-12 gap-x-4 items-center">
            <div className="col-span-6 flex flex-col gap-8">
              <div className="flex gap-2 min-lg:mx-0">
                <img src="/img/check.svg" alt={t('consulting.discount')} width={24} height={24} />
                <p className="text-success text-sm font-semibold" style={{ textAlign: isRtl ? 'right' : 'left' }}>
                  {t('consulting.discount')}
                </p>
              </div>
              <h4 className="text-blue-900 text-4xl min-sm:text-5xl font-semibold min-lg:pt-0">
                {t('consulting.main_title')}
              </h4>
              <h3 className="text-blue-700 text-lg/8 min-lg:pt-0" style={{ textAlign: isRtl ? 'right' : 'left' }}>
                {t('consulting.subtitle')}
              </h3>
              <form onSubmit={handleSearch} className="relative rounded-full min-lg:pt-0">
  <input
    type="text"
    value={searchInput}
    onChange={(e) => setSearchInput(e.target.value)}
    className={`py-6 min-lg:py-8 ${isRtl ? 'pr-8 pl-20' : 'pl-8 pr-20'} text-lg w-full text-black rounded-full focus:outline-none shadow-input-shadow`}
    placeholder={t('consulting.search_placeholder')}
    autoComplete="off"
    style={{ textAlign: isRtl ? 'right' : 'left' }}
  />
  <button
    type="submit"
    className={`bg-secondary p-3 rounded-full absolute ${isRtl ? 'left-2' : 'right-2'} top-2`}
  >
    <img src="/img/search.svg" alt={t('consulting.search_alt')} width={24} height={24} />
  </button>
</form>
              <div className="flex flex-wrap items-center justify-between pt-10 min-lg:pt-4 gap-4">
                <div className="flex gap-2 items-center">
                  <img src="/img/check-circle.svg" alt={t('consulting.flexible')} width={30} height={30} className="smallImage" />
                  <p className="text-sm min-sm:text-lg font-normal text-blue-900">{t('consulting.flexible')}</p>
                </div>
                <div className="flex gap-2 items-center">
                  <img src="/img/check-circle.svg" alt={t('consulting.learning_path')} width={30} height={30} className="smallImage" />
                  <p className="text-sm min-sm:text-lg font-normal text-blue-900">{t('consulting.learning_path')}</p>
                </div>
                <div className="flex gap-2 items-center">
                  <img src="/img/check-circle.svg" alt={t('consulting.community')} width={30} height={30} className="smallImage" />
                  <p className="text-sm min-sm:text-lg font-normal text-blue-900">{t('consulting.community')}</p>
                </div>
              </div>
            </div>
            <div className="col-span-6 flex justify-center">
              <img src="/img/mahila.png" alt={t('consulting.hero_image_alt')} width={1000} height={805} />
            </div>
          </div>
        </div>
      </section>
      {/* نهاية قسم البطل */}

      {/* قسم التبويبات */}
      <section className="py-[160px] pt-0 border-t border-lightgray overflow-hidden min-lg:py-[120px] min-md:py-[95px] min-sm:py-[80px] min-xs:py-[50px]">
        <Tab07 data={TabData07} />
      </section>
      {/* نهاية قسم التبويبات */}

{/* Reste sala7hom */}

      {/* قسم  */}
      <section className="text-blue-900 py-[160px] pt-0 text-center text-xxl overflow-hidden min-lg:py-[120px] min-md:py-[95px] min-sm:py-[80px] min-xs:py-[50px]">
        <p>
          {t('consulting.home_title')}
        </p>
      </section>
      {/* نهاية قسم  */}
<section id="baccalaureat" className="relative z-10 max-w-7xl mx-auto px-4 min-sm:px-6 min-lg:px-8 py-20">
        <div className="text-center mb-16 space-y-4 animate-fadeInUp">
          <h3 className="text-4xl font-bold text-blue-900">{t('bac.section_title')}</h3>
          <p className="text-xlg font-semibold text-blue-700 max-w-6xl mx-auto">{t('bac.description_placeholder')}</p>
        </div>

        <div className="grid grid-cols-1 min-sm:grid-cols-2 min-lg:grid-cols-3 gap-8">
          {bacCategories.map((category, idx) => (
            <Link to="/course" aria-label={t('document_details.documents_link')}>
                <div
              key={category.id}
              onClick={() => setSelectedBacCategory(category.id)}
              className={`cursor-pointer p-8 rounded-xl border-2 transition-all duration-300 transform hover:scale-105 animate-fadeInUp ${
                selectedBacCategory === category.id
                  ? "border-orange-400 bg-orange-50 shadow-xl shadow-orange-400/30"
                  : "border-blue-200 bg-white hover:border-orange-300 hover:shadow-lg"
              }`}
              style={{ animationDelay: `${idx * 0.15}s` }}
            >
              <div className="text-xxlg mb-4 text-center">{category.icon}</div>
              <h4 className="text-xl font-semibold text-blue-900 text-center">{category.name}</h4>
              <p className="text-sm text-blue-600 text-center mt-2">{t('bac.explore')}</p>
              {selectedBacCategory === category.id && (
                <div className="mt-4 pt-4 border-t border-orange-200 text-center">
                  <p className="text-sm font-semibold text-orange-500">{t('bac.selected')}</p>
                </div>
              )}
            </div>
          </Link>
          ))}
        </div>
      </section>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="my-16 text-center"
        >
          <p className="text-blue-900 text-xlg font-semibold mb-6">
            {t('cta_description')}
          </p>
          <Link to="/inscription">
               <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="px-20 py-4 rounded-full text-white font-bold text-xlg transition-all"
            style={{ backgroundColor: "#f29f2f" }}
          >
            {t('cta_button')}
          </motion.button>
          </Link>
        </motion.div>

    </div>
  );
};

export default Home;